/**
 * Public NoCodeBackend Service
 * Handles read-only operations for public data.
 */

const BASE_URL = 'https://api.nocodebackend.com';
const INSTANCE = '54230_clouds_boarding_house_portal';

/**
 * Retrieves a list of buildings from the live NoCodeBackend database.
 * @returns {Promise<Array>} List of building records.
 */
export async function getLiveBuildings() {
  const url = new URL('/read/buildings', BASE_URL);
  url.searchParams.set('Instance', INSTANCE);
  url.searchParams.set('limit', '10');

  const response = await fetch(url.toString(), {
    method: 'GET',
    headers: {
      'Accept': 'application/json'
    }
  });

  if (!response.ok) {
    throw new Error(`HTTP ${response.status}`);
  }

  const payload = await response.json();

  if (!payload || !Array.isArray(payload.data)) {
    throw new Error('Invalid response format: data is not an array');
  }

  return payload.data;
}